import 'react-app-polyfill/ie9';// This must be the first line in src/index.js
import 'core-js/features/array/find-index';
import 'core-js/features/array/find';
import React from 'react';
import ReactDOM from 'react-dom';
import './static/css-importer';
import App from './app';
import * as serviceWorker from './serviceWorker';

ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();